export default __webpack_public_path__ + "static/media/PortfolioWebsite.0a407214.png";